export default class RenderingObject {
  // eslint-disable-next-line class-methods-use-this
  draw() {
    // console.log('test');
  }
}
